import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../interceptor/axiosInstance";
import { useNavigate } from "react-router-dom";
import NotificationService from "../Utils/NotificationService"; // Import notification service

const OrganizationDetails = () => {
  // Formik for form handling and validation
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [error, setError] = useState(null);

  const [isSignupSuccessful, setIsSignupSuccessful] = useState(false);

  const [organisation, setOrganisation] = useState({
        org_id: 1,
        user_id: 2,
        organisation_name: "Netsutra",
        organisation_code: "6E6C9-21A57-2D113-14AF8-9CCFD",
        status: 1,
        mobile_number: "1234567890",
        address: "1FCS-40",
        created_at: "2024-11-29T05:33:27.000Z",
        email: "org@netsutra.com",
        subscription: [
          { type: 'chat', name: 'Virtual chat', enabled: true },
          { type: 'chat', name: 'Chat with agent', enabled: false },
          { type: 'ticket', name: 'Ticket', enabled: true }
        ]
      });

  const formik = useFormik({
    initialValues: {
      organisationName: organisation.organisation_name,
      mobileNumber: organisation.mobile_number,
      address: organisation.address,
      subscriptions: organisation.subscription,
    },
    validationSchema: Yup.object({
      organisationName: Yup.string()
        .required("Organization Name is required")
        .max(50, "Must be 50 characters or less"),
      mobileNumber: Yup.string()
        .required("Phone Number is required")
        .matches(/^\d{10}$/, "Must be a valid 10-digit phone number"),
      address: Yup.string().required("Address is required"),
    }),

    onSubmit: async (payload, { resetForm }) => {
      console.log("Form Submitted:", payload);

      try {
        const response = await axiosInstance.post(`/auth/sign-up`, payload);
        console.log(response.data)
        setData(response.data); // Handle response data
        setError(null); // Clear any previous errors
        resetForm(); 
        setIsSignupSuccessful(true);
      } catch (err) {
        if(err.response.data.error === "ALREADY EXIST") {
          NotificationService.error("An organization with the provided email address already exists. Please use a different email address.")
        }
        setError(err.message); // Handle error
        setData("");
      }
    },
  });

  // Handler to toggle individual subscription features
  const handleSubscriptionToggle = (name) => {
    setOrganisation({
      ...organisation,
      subscription: organisation.subscription.map((sub) =>
        sub.name === name ? { ...sub, enabled: !sub.enabled } : sub
      ),
    });
    formik.values.subscriptions = formik.values.subscriptions
      .map((sub) =>sub.name === name ? { ...sub, enabled: !sub.enabled } : sub);
  };

  const goToManageOrganisationPage = () => {
    navigate("/manage-organisation");
  };

  return (
  <div className="container mt-5">
  <div className="row justify-content-center">
    <div className="col-md-8">
      <div className="card shadow">
        <div className="card-header header-color text-white position-relative">
        <button className="back-button-padding btn position-absolute" onClick = {goToManageOrganisationPage}>Back</button>
          <h4 className="text-center mb-0">Organisation Settings</h4>
        </div>

        <div className="card-body">
          <form onSubmit={formik.handleSubmit}>
            {/* Organization Name */}
            <div className="mb-4">
              <label htmlFor="organisationName" className="form-label fw-bold">
                Organization Name
              </label>
              <input
                id="organisationName"
                name="organisationName"
                type="text"
                className={`form-control ${
                  formik.touched.organisationName &&
                  formik.errors.organisationName
                    ? "is-invalid"
                    : ""
                }`}
                value={formik.values.organisationName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.organisationName &&
                formik.errors.organisationName && (
                  <div className="invalid-feedback">
                    {formik.errors.organisationName}
                  </div>
                )}
            </div>

            {/* Phone Number */}
            <div className="mb-4">
              <label htmlFor="mobileNumber" className="form-label fw-bold">
                Phone Number
              </label>
              <input
                id="mobileNumber"
                name="mobileNumber"
                type="text"
                className={`form-control ${
                  formik.touched.mobileNumber && formik.errors.mobileNumber
                    ? "is-invalid"
                    : ""
                }`}
                value={formik.values.mobileNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.mobileNumber &&
                formik.errors.mobileNumber && (
                  <div className="invalid-feedback">
                    {formik.errors.mobileNumber}
                  </div>
                )}
            </div>

            {/* Address */}
            <div className="mb-4">
              <label htmlFor="address" className="form-label fw-bold">
                Address
              </label>
              <textarea
                id="address"
                name="address"
                rows="3"
                className={`form-control ${
                  formik.touched.address && formik.errors.address
                    ? "is-invalid"
                    : ""
                }`}
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.address && formik.errors.address && (
                <div className="invalid-feedback">{formik.errors.address}</div>
              )}
            </div>

            {/* Chat Subscriptions */}
            <div className="mb-4">
              <label className="form-label fw-bold">
                Chat Subscriptions
              </label>
              {formik.values.subscriptions
                .filter((sub) => sub.type === "chat")
                .map((sub) => (
                  <div className="form-check" key={sub.name}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={sub.enabled}
                      onChange={() => handleSubscriptionToggle(sub.name)}
                    />
                    <label className="form-check-label">{sub.name}</label>
                  </div>
                ))}
            </div>

            {/* Ticket Subscriptions */}
            <div className="mb-4">
              <label className="form-label fw-bold">
                Ticket Subscriptions
              </label>
              {formik.values.subscriptions
                .filter((sub) => sub.type === "ticket")
                .map((sub) => (
                  <div className="form-check" key={sub.name}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={sub.enabled}
                      onChange={() => handleSubscriptionToggle(sub.name)}
                    />
                    <label className="form-check-label">{sub.name}</label>
                  </div>
                ))}
            </div>

            {/* Submit Button */}
            <div className="d-grid">
              <button type="submit" className="btn btn-success">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
)};

export default OrganizationDetails;